import React, { useState } from 'react';

export const useVisibility = (initialState: boolean): [boolean, () => void] => {
  const [visibility, setVisibility] = useState<boolean>(initialState);

  function toggleVisibility(): void {
    setVisibility((prev: boolean) => !prev);
  }

  return [visibility, toggleVisibility];
};
